var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGhBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 93,
    viewBox: "0 0 96 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5937 67.9688C28.2187 66.4688 19.5 57.5625 19.5 46.0313C19.5 41.3438 21.1875 36.2813 24 32.9063C22.7812 29.8125 22.9687 23.25 24.375 20.5313C28.125 20.0625 33.1875 22.0313 36.1875 24.75C39.75 23.625 43.5 23.0625 48.0937 23.0625C52.6875 23.0625 56.4375 23.625 59.8125 24.6563C62.7187 22.0313 67.875 20.0625 71.625 20.5313C72.9375 23.0625 73.125 29.625 71.9062 32.8125C74.9062 36.375 76.5 41.1563 76.5 46.0313C76.5 57.5625 67.7812 66.2813 55.2187 67.875C58.4062 69.9375 60.5625 74.4375 60.5625 79.5938V89.344C60.5625 92.156 62.9062 93.75 65.7187 92.625C82.6875 86.156 96 69.1875 96 48.1875C96 21.6563 74.4375 0 47.9062 0C21.375 0 0 21.6562 0 48.1875C0 69 13.2187 86.25 31.0312 92.719C33.5625 93.656 36 91.969 36 89.438V81.9375C34.6875 82.5 33 82.875 31.5 82.875C25.3125 82.875 21.6562 79.5 19.0312 73.2188C18 70.6875 16.875 69.1875 14.7187 68.9063C13.5937 68.8125 13.2187 68.3438 13.2187 67.7813C13.2187 66.6563 15.0937 65.8125 16.9687 65.8125C19.6875 65.8125 22.0312 67.5 24.4687 70.9688C26.3437 73.6875 28.3125 74.9063 30.6562 74.9063C33 74.9063 34.5 74.0625 36.6562 71.9063C38.25 70.3125 39.4687 68.9063 40.5937 67.9688Z",
    fill: "#2A3143"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 93,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhBlack);
export default __webpack_public_path__ + "static/media/ghBlack.a0017c0f69526f99a65abcb991fe5f18.svg";
export { ForwardRef as ReactComponent };